import React from "react";

export const OrganizationShape = (props) => {
  const { cx, cy, payload } = props;
  const radius = 60;

  return (
    <g>
      <circle
        cx={cx}
        cy={cy}
        r={radius}
        fill="#6b7280"
        fillOpacity={0.3}
        stroke="#6b7280"
        strokeWidth={2}
        strokeOpacity={0.8}
      />
      <text
        x={cx}
        y={cy + radius + 15}
        textAnchor="middle"
        className="fill-black dark:fill-white"
        fontSize={14}
        fontWeight="600"
      >
        {payload?.name || "Organization"}
      </text>
    </g>
  );
};
